<template>
  <div>
    <!--暂无数据-->
    <div v-if="nullData" class="no-data-box" >
      <img class="no-data-img" src="@/assets/common/moblie-no-data.png" />
      <span class="no-data-text" style="left: 0;top: 130px;" >{{dataNews}}</span>
    </div>
    <div v-else class="eva-details">
      <div class="details-btns">
        <!-- 教师信息 -->
        <div class="details-teacher" @click="changeTeacher(0)">
          <span>{{teacherFullName}}</span>&nbsp;&nbsp;
          <van-icon name="arrow" />
        </div>
        <div @click="changeTeacher(1)" class="details-card">答题卡</div>
      </div>
      <div v-if="teacherList.length>0" style="padding:22px; min-height: 2rem;">
        <div v-if="quesNum===1" class="details-project">
          <div class="project-info-title" >{{projectObject.QuestionnaireTitle}}</div>
          <div class="project-info">
            <div class="project-info-name">被评价者：</div>
            <div class="project-flex1" >{{teacherFullName}}</div>
          </div>
          <div v-if="projectObject.ProjectDescr !== '' && projectObject.ProjectDescr !== null" class="project-info">
            <div class="project-info-name">方案描述：</div>
            <div class="project-flex1" >{{projectObject.ProjectDescr}}</div>
          </div>
          <div class="project-info">
            <div class="project-info-name">截止时间：</div>
            <div class="project-flex1" >{{xy.moment(projectRow.EndDate).format('YYYY-MM-DD HH:mm')}}</div>
          </div>
        </div>
        <div class="details-content pr">
          <div>
            <!-- 题号题目 -->
            <template v-for="(item, index) in quesitonList">
              <div :key="index" class="details-title" v-if="(index+1) === quesNum">
                <span v-if="item.IsMust" style="color:red;">*</span>
                <span>{{index+1}}.&nbsp;&nbsp;{{item.QuestionName}}</span>
                <!-- 1.单选 2.多选 （本期先不考虑） 3.打分 4.问答 -->
                <!-- <span v-if="item.QuestionType === 1">（单选题）</span>
                <span v-if="item.QuestionType === 3">（打分题）</span>
                <span v-if="item.QuestionType === 4">（问答题）</span> -->
              </div>
            </template>
            <!-- 题目选项 -->
            <div class="details-question">
              <div v-for="(item, index) in quesitonList" :key="index">
                <div v-if="(index+1) === quesNum">
                  <!-- 单选题 -->
                  <div v-if="item.QuestionType === 1">
                    <van-radio-group v-model="allAnswers[index].Answers" class="select-group">
                      <van-radio v-for="(child,i) in item.Options" :key="i"
                          :name="child.QuestionOptionID" 
                          class="select-group-radio">{{child.QuestionOptionName}}</van-radio>
                    </van-radio-group>
                  </div>
                  <!-- 打分题 -->
                  <div v-if="item.QuestionType === 3" class="rate-question">
                    <van-rate v-model="allAnswers[index].Answers"
                      @change="changeRate(allAnswers[index].QuestionID)"
                      :size="24"
                      :count="item.Options.length"
                      active-color="#f5a623" />
                    <span class="rate-info">{{allAnswers[index].AnswersInfo}}</span>
                  </div>
                  <!-- 问答题 -->
                  <div v-if="item.QuestionType === 4"  class="answer-question">
                    <van-cell-group>
                      <van-field
                        clearable
                        type="textarea"
                        v-model="allAnswers[index].Answers"
                        label="您的回答："
                        placeholder="请输入..." />
                    </van-cell-group>
                  </div>
                </div>
              </div>
              <div class="details-question-btn">
                <div v-if="this.quesNum !== 1" class="details-question-btn-prev" @click="prevBtn">上一题</div>
                <div v-if="teachingProjectStatus === 2" class="details-question-btn-prev">已完成答题</div>
                <div v-if="nextBtnName === '下一题'" class="details-question-btn-next" @click="nextBtn">{{nextBtnName}}</div>
                <div v-if="nextBtnName === '提交'" class="details-question-btn-next" @click="submit">{{nextBtnName}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框选择 -->
    <div class="details-alert" v-if="isShowAlert">
      <van-icon name="close" @click="closeBtn" class="details-icon" />
      <div class="alert-title" >{{alertTitle}}</div>
      <!-- 选择教师 -->
      <div v-if="alertTypes===0">
        <ul class="clearfix">
          <li
            v-for="(item,index) in teacherList"
            :key="item.TeacherId"
            class="teacher-change-list fl">
            <div
              class="teacher-change-list-name"
              :class="index===teacherIndex?'active':''"
              @click="changeTeacherBtn(item,index)">
              <span >{{item.TeacherFullName}}</span>
              <i class="fa fa-check" v-if="index===teacherIndex"></i>
            </div>
          </li>
        </ul>
      </div>
      <!-- 答题卡 -->
      <div v-if="alertTypes===1">
        <ul class="clearfix card-que">
          <li v-for="(item, index) in quesitonList" :key="index" class="fl">
            <div class="position-nums"
              :class="(index+1) === quesNum ? 'active':''"
              @click="numBtn(item,index)">{{index+1}}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EvaOfTeacherDetail",
  components: {},
  data() {
    return {
      messageInfo:{},//消息页信息
      ServiceDoMainName: "",
      nullData: false,

      isShowAlert: false,
      alertTypes: 0, //弹框类型：0选教师、1选答题卡
      alertTitle: "",

      teacherFullName: "请选择教师",
      teacherList: [],
      teacherIndex: 0, //当前选中教师索引
      teachingStudentID: 0, //选择教师获取
      teachingTeacherID: 0, //选择教师获取
      questionnaireID: 0,//问卷id-选择教师获取

      projectRow:{}, //列表方案信息
      teachingProjectID:0,//方案id
      projectObject: {}, //答题页获取的方案以及题目信息
      teachingProjectStatus: 0, //方案状态：0未开始（之前：0未启用/已停用） 1进行中 2已结束
      quesitonList: [], //题目列表

      quesNum: 1, //当前题目题号
      quesNumIndex: 0, //当前题目索引
      curQuestionType: 0,//当前题目的题类型
      nextBtnName: "下一题", //"提交"or"下一题"
      
      allAnswers: [], //答案参数

      changedRate: false,
      curRateOption: [] //当前展示题目（打分题）的选项
    };
  },
  created() {
    // 判断是否是从消息列表里传来的值
    if (this.$route.query.fromMessage) {
      this.messageInfo = JSON.parse(this.$store.state.messageInfo);
      // 字符串转json
      this.messageInfo = this.messageInfo.messageInfo;
      this.ServiceDoMainName = this.messageInfo.ServiceDoMainName;
      if (this.messageInfo !== null) {
        this.teachingProjectID = JSON.parse(this.messageInfo).TeachingProjectID;
      }
    } else {
      // 从列表跳转
      this.ServiceDoMainName = this.$store.state.apiPath;
      this.projectRow = this.$store.state.evaluation.teachingProjectRow
      this.teachingProjectID = this.$store.state.evaluation.teachingProjectRow.TeachingProjectID;
      this.teachingProjectStatus = this.$store.state.evaluation.teachingProjectRow.TeachingProjectStatus;
    }
    if (this.teachingProjectID !== "") {
      this.getTeacherList();
    }
  },
  methods: {
    // 打分题change
    changeRate(curRateId){
      for(let i = 0; i< this.quesitonList.length; i++){
        if(this.quesitonList[i].QuestionID === curRateId){
          this.changedRate = true
          // 获取当前打分题的选项(返回的)
          this.curRateOption = this.quesitonList[i].Options
        }
      }
      for(let i = 0; i < this.allAnswers.length; i++){
        if(this.allAnswers[i].QuestionID === curRateId){ // 获取当前打分题的选项(组合后的)
          for(let j = 0; j < this.curRateOption.length; j++){
            if(this.allAnswers[i].Answers === this.curRateOption[j].StartCount){
              this.allAnswers[i].AnswersInfo = this.curRateOption[j].QuestionOptionName
            }
          }
        }
      }
    },
    // 获取我的评教老师
    async getTeacherList() {
      let res = await this.xyapi.get(this.ServiceDoMainName + "/api/StudentTeachingReport/GetMyEVATeachers",{
        teachingProjectID: this.teachingProjectID
      })
      if (res.success) {
        if (res.data.length > 0) {
          if (this.teachingProjectStatus !== 0) {
            this.teacherList = res.data;
            this.teacherFullName = this.teacherList[0].TeacherFullName;
            this.teachingTeacherID = this.teacherList[0].TeachingTeacherID;
            this.teachingStudentID = this.teacherList[0].TeachingStudentID;
            this.questionnaireID = this.teacherList[0].QuestionnaireID;
            this.nullData = false;
            this.getProjectByID();
          }
        }
      } else {
        this.xy.msgError(res.msg)
      }
    },
    // 获取问卷（有答案的会带答案）
    async getProjectByID() {            
      let res = await this.xyapi.get(this.ServiceDoMainName + "/api/StudentTeachingAnswer/GetMyQuestionaire", {
        questionnaireID: this.questionnaireID, //问卷id 
        teachingTeacherID: this.teachingTeacherID,
        teachingStudentID: this.teachingStudentID
      })
      if (res.success) {
        this.allAnswers = []
        this.projectObject = res.data;
        // 获取题目
        this.quesitonList = res.data.Questions

        // 题目答案集合
        for(var i = 0; i< this.quesitonList.length; i++){
          var obj = {
            QuestionID: -1,
            Answers: -1, //打分和单选必须为Number
            IsMust: this.quesitonList[i].IsMust
          }
          obj.QuestionID = this.quesitonList[i].QuestionID
          if(this.quesitonList[i].QuestionType === 1){
            this.quesitonList[i].Options.map(item=>{
              if (item.IsChecked){
                obj.Answers = item.QuestionOptionID
              }
            })
          }else if(this.quesitonList[i].QuestionType === 3){
            this.quesitonList[i].Options.map(item=>{
              if (item.IsChecked){
                obj.Answers = item.StartCount
                obj.AnswersInfo = item.QuestionOptionName
              }
            })
          }else if(this.quesitonList[i].QuestionType === 4){
            obj.Answers = this.quesitonList[i].AnswerText !== null ? this.quesitonList[i].AnswerText : ''
          }
          this.allAnswers.push(obj)
        }
        if (this.quesNum === this.quesitonList.length ) {
          this.nextBtnName = "提交";
        } else {
          this.nextBtnName = "下一题";
        }
      }
    },
    // 选择老师/答题卡
    changeTeacher(type) {
      this.alertTypes = type;
      if (this.alertTypes === 0) {
        if (this.teacherList.length > 0) {
          this.alertTitle = "选择教师";
          this.isShowAlert = true;
        } else {
          this.xy.msgError('没有教师可供选择');
        }
      } else {
        if (this.quesitonList.length > 0) {
          this.alertTitle = "答题卡";
          this.isShowAlert = true;
        } else {
          this.xy.msgError('当前评价方案没有题目');
        }
      }
    },
    // 选择教师
    changeTeacherBtn(vals, index) {
      this.quesNum = 1; //题号
      this.teacherIndex = index;
      this.teacherFullName = vals.TeacherFullName;

      this.teachingStudentID = vals.TeachingStudentID
      this.teachingTeacherID = vals.TeachingTeacherID
      this.questionnaireID = vals.QuestionnaireID
      this.isShowAlert = false;
      this.getProjectByID();
    },
    // 答题卡选择题号
    numBtn(vals, index) {
      this.quesNum = index + 1; //题号
      if (this.quesNum === this.quesitonList.length) {
        this.nextBtnName = "提交";
      } else {
        this.nextBtnName = "下一题";
      }
      this.isShowAlert = false;
    },
    //取消选择
    closeBtn() {
      this.isShowAlert = false;
    },
    // 上一题
    prevBtn() {
      if (this.quesNum === 1) {
        this.xy.msgError('当前已经是第一题');
      } else {
        this.nextBtnName = "下一题";
        this.quesNum --;
      }
    },
    // 下一题
    async nextBtn() {
      if(this.quesNum < this.quesitonList.length){
        this.nextBtnName = "下一题";
        this.quesNum ++
      }
      if (this.quesNum === this.quesitonList.length) {
        this.nextBtnName = "提交";
      }
    },

    // 提交
    async submit() {
      this.xy.loading();
      for (let i = 0; i < this.allAnswers.length; i++) {
        //必填项
        if (this.allAnswers[i].IsMust) {
          //===''判断问答未填， ===-1判断单选打分未填
          if( this.allAnswers[i].Answers === '' ||  this.allAnswers[i].Answers === -1){
            this.xy.msgError(`请填写第${i + 1}题`)
            return false
          }
        }
        //Answers类型有问题待联调优化？？？
        // === -1判断单选打分未填 
        if(this.allAnswers[i].Answers === -1){
          this.allAnswers[i].Answers = ''
        }else{
          // !== '' 判断问答已填
          if(this.allAnswers[i].Answers !== ''){
            this.allAnswers[i].Answers = [this.allAnswers[i].Answers + '']
          }
        }
      }
      let res = await this.xyapi.post(this.ServiceDoMainName + "/api/StudentTeachingAnswer/Answer", {
        TeachingStudentID: this.teachingStudentID,
        TeachingTeacherID: this.teachingTeacherID,
        TeachingProjectID: this.teachingProjectID,
        QuestionnaireID: this.questionnaireID,
        Details: this.allAnswers
      })
      if (res.success) {
        this.xy.unloading();
        this.xy.msgSuc('评价完成')
        this.getProjectByID() //重置选中值的类型
      } else {
        this.xy.unloading();
        this.xy.msgError(res.msg)
      }
    }

  }
}
</script>
<style lang="less" scoped>
.eva-details {
  position: absolute;
  left: 0;
  right: 0;
  font-size: 26px;
  overflow: hidden;
  width: 100%;
  overflow-y: auto;
  background: linear-gradient(180deg,  rgba(65, 150, 255, 1) 0%, rgba(47, 90, 255, 1) 100%);
  height: 100%;
}
.details-btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 40px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  font-size: 28px;
  color: #fff;
}
.details-teacher{
  display: flex;
  justify-content: center;
  align-items: center;
}
.details-card {
  width: 146px;
  height: 64px;
  line-height: 64px;
  border: 2px solid #fff;
  border-radius: 32px;
  text-align: center;
}
.details-alert {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  overflow-y: auto;
}
.details-icon {
  color: #fff;
  position: absolute;
  right: 60px;
  top: 60px;
  font-size: 50px;
}
.details-project {
  color: #fff;
  margin-bottom: 50px;
}
.project-info-title {
  font-size: 28px;
  margin-bottom: 35px;
}
.project-info {
  line-height: 40px;
  display: flex;
  margin-bottom: 15px;
}
.project-flex1 {
  flex: 2;
  color: #f1f1f1;
}
.project-info-name {
  color: #b6bff6;
}
.details-title {
  font-weight: 700;
  font-size: 34px;
  color: #fff;
  margin-bottom: 50px;
}
.details-question {
  background: #fff;
  border-radius: 20px;
  padding: 45px;
  min-height: 10rem;
}
.select-group{
  font-size: 28px;
}
.select-group .select-group-radio{
  margin-bottom: 20px;
}
.rate-question{
  display: flex;
  align-items: center;
}
.rate-info{
  margin-left: 20px;
}
.answer-question{
  font-size: 28px;
}
.details-question-btn {
  display: flex;
  margin-top: 120px;
  font-size: 30px;
}
.details-question-btn > div {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.details-question-btn-prev {
  color: #444;
}
.details-question-btn-next {
  height: 89px;
  border-radius: 45px;
  background: #4196ff;
  color: #fff;
}
.alert-title {
  color: #fff;
  font-size: 32px;
  text-align: center;
  margin-top: 150px;
  margin-bottom: 75px;
}
.card-que{
  padding: 0 35px;
}
.card-que li{
  width:20%;
  text-align:center;
  margin-bottom: 50px;
}
.position-nums {
  width: 68px;
  height: 68px;
  line-height: 68px;
  text-align: center;
  border: 2px solid rgba(255, 255, 255, 0.4);
  color: rgba(255, 255, 255, 0.4);
  font-size: 30px;
  border-radius: 50%;
  display: inline-block;
}
.position-nums.active {
  background: #fff;
  border: 2px solid #fff;
  color: #333;
}
.teacher-change-list {
  width: 50%;
  margin-bottom: 70px;
  text-align: center;
}
.teacher-change-list-name {
  font-size: 34px;
  color: rgba(255, 255, 255, 0.7);
}
.teacher-change-list-name.active > span,
.teacher-change-list-name.active > i {
  color: #fff;
}
.teacher-change-list-name.active > span {
  font-weight: 700;
}
</style>
